var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('h3',[_vm._v("Maps")]),_vm._l((_vm.maps),function(map){return _c('MapItem',{key:map.id,attrs:{"map":map},on:{"onMapClick":_vm.onMapClick}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }